import React, { useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Page from '../../component/Page';
import RequireField from '../../component/RequireField';
import { Box, Button, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default function ViewNews() {
    const fileRef = useRef(null);
    const navigate = useNavigate();

    const { id } = useParams()
    const [materialName, setMaterialName] = useState()
    const [status, setStatus] = useState('Y')
    const [detail, setDetail] = useState()
    const [file, setFile] = useState()
    const [data, setData] = useState('')
    const handleFileInput = (e) => {
        // handle validations
        const file = e.target.files[0]
        setFile(URL.createObjectURL(file));
        e.target.value = null
    }
    const handleSubmit = async () => {
    }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => {
            resolve(reader.result)
          }
          reader.onerror = reject
        })
      }
      
    const uploadAdapter = (loader) => {
        return {
            upload: async () => {
                const file = await loader.file;
                const base64 = await getBase64(file);
                return {
                    default: base64,
                };
            },
        };
    }
    function uploadPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid">

                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                {id ? 'รายละเอียดข่าวสาร' : 'เพิ่มข่าวสาร'}
                            </label>


                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ชื่อ</label>
                            <RequireField value={materialName} onChange={setMaterialName} type={'text'} error={''} setError={null} textError={'กรุณากรอกชื่อ'} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '20px 0' }}>
                            <label class="labelInput">ภาพปก</label>
                            <input
                                type="file"
                                ref={fileRef}
                                accept="image/*"
                                hidden
                                onChange={handleFileInput}
                            />
                            <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => fileRef.current && fileRef.current.click()}>อัพโหลดภาพ</Button>
                            {/* <img src={file} height='auto' width={440} /> */}
                            <Box
                                sx={{
                                    height: "200px",
                                    marginTop: "20px",
                                    width: "300px",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    backgroundImage: `url(${file || 'https://placehold.co/300x200?text=Image'})`,
                                }}
                            ></Box>
                        </div>
                        <div style={{ margin: '20px 0' }}>
                            <label class="labelInput">เนื้อหา</label>
                            <CKEditor
                                height="500px"
                                editor={ClassicEditor}
                                config={{
                                    extraPlugins: [uploadPlugin],
                                }}
                                data={data}
                                onReady={editor => {
                                    // You can store the "editor" and use when it is needed.
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setData(data)
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                }}
                            />
                        </div>
                        {id &&
                            <div class="row" >
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            </div >}
                        <div class="col-md-12 mt-1  text-left ">
                            <div class="d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
                                <RadioGroup row
                                    value={status} onChange={e => setStatus(e.target.value)}
                                >
                                    <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                                    <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                                </RadioGroup>
                            </div>

                        </div>


                    </div >


                    <hr class="chr" />
                    <div class="row ">
                        <div class="col-12 text-left">
                            <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                            <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => handleSubmit()}>{id ? 'เเก้ไข' : 'บันทึก'}</Button>
                        </div >
                    </div >
                    
                </div >



            </Page >
        </div >
    )
}
